import * as actionTypes from 'actions';

const initialState = {
    Loading: false,
    faceApprovalList: [],
    faceApprovalDropdownList: [],
    faceApprovalRecord:[],
    validation_error: "",
    redirect_to_list: false,
    showDeleteModel: false,
    showUpdateForm: false,
    showViewPage: false,
}

const FaceApprovalReducer = (state = initialState, action) => {
    switch (action.type) {
       
    case actionTypes.FACE_APPROVAL_REQUEST:
        return {
          ...state,
          Loading: true,
          validation_error: "",
          redirect_to_list: false,
        }
    case actionTypes.FACE_APPROVAL_SERVER_SUCCESS:
        return {
          ...state, 
          Loading: false,
          redirect_to_list: false,
          validation_error: "",
          showUpdateForm: false,
          showViewPage: false,
          faceApprovalRecord: [],
        }      
    case actionTypes.FACE_APPROVAL_SUCCESS:
        return {
          ...state, 
          Loading: false,
          redirect_to_list: false,
          validation_error: "",
          faceApprovalList: action.faceApprovalList,
          showUpdateForm: false,
          showViewPage: false,
          faceApprovalRecord: [],
        }    
    case actionTypes.FACE_APPROVAL_DROPDOWN_LIST_SUCCESS:
        return {
            ...state,
            Loading: false,
            faceApprovalDropdownList: action.faceApprovalDropdownList,
        }    
    case actionTypes.FACE_APPROVAL_GET_SUCCESS:
        return {
            ...state, 
            Loading: false,
            redirect_to_list: false,
            faceApprovalRecord: action.record,
            showUpdateForm: (action.actionType === 'update')? true:false,
            showViewPage: (action.actionType === 'view')? true:false
        }    
    case actionTypes.FACE_APPROVAL_VALIDATION_ERROR:
        return {
            ...state,
            Loading: false,
            redirect_to_list: false,
            validation_error: action.validation_error,
        } 
    case actionTypes.HIDE_FACE_APPROVAL_FEILD_VALIDATION_ERROR:
        if(state.validation_error && state.validation_error[action.feild_key])
            delete state.validation_error[action.feild_key]
        return {
            ...state,
            Loading: false,
            redirect_to_list: false,
            validation_error: action.validation_error,
            
        } 
    case actionTypes.REDIRECT_TO_FACE_APPROVAL_LIST:
        return {
            ...state,
            redirect_to_list: true,
            showUpdateForm: false,
            showViewPage: false,
            validation_error: '',
            faceApprovalRecord: [],
        }        
    default:
        return state;
    }
}

export default FaceApprovalReducer;